import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, Navigate } from "react-router-dom";
import { MarketingCallStatusSelect } from "components/MarketingCallStatus";

export default class WebContacts extends Component {
  state = {
    allJobs: [],
    message: "",
    notification: false,
    noticolor: "success",
    per_pge: 20,
    page_no: 1,
    redirect: false,
    updatingCallStatus: {},
  };
  componentDidMount() {
    this.getAllWebContacts();
  }

  getAllWebContacts = () => {
    if (init() === "success") {
      // console.log("called");
      axios
        .get(Constants.getUrls.getAllWebContacts)
        .then((resp) => {
          console.log(resp);
          if (resp.data.status === "success") {
            this.setState({
              allJobs: resp.data.data.docs,
              notification: true,
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState({
                notification: false,
                message: "",
              });
            }, 2500);
          } else {
            this.setState({ notification: true, message: resp.data.message });
          }
        })
        .catch((err) => {
          //   console.log(err);
          this.setState({
            notification: true,
            message: err.response?.message,
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              message: "",
            });
          }, 2500);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  handleCallStatusChange = (contactId, callStatus) => {
    if (init() !== "success") return;

    this.setState((current) => ({
      updatingCallStatus: { ...current.updatingCallStatus, [contactId]: true },
    }));

    axios
      .put(`${Constants.putUrls.updateWebContactCallStatus}${contactId}/call-status`, {
        call_status: callStatus,
      })
      .then((response) => {
        const savedStatus = response?.data?.data?.marketing_call_status || callStatus;
        this.setState((current) => ({
          allJobs: current.allJobs.map((contact) =>
            contact._id === contactId
              ? { ...contact, marketing_call_status: savedStatus }
              : contact
          ),
          notification: true,
          noticolor: "success",
          message: response?.data?.message || "Call status updated successfully.",
        }));
      })
      .catch((error) => {
        this.setState({
          notification: true,
          noticolor: "error",
          message: error?.response?.data?.message || "Unable to update call status.",
        });
      })
      .finally(() => {
        this.setState((current) => ({
          updatingCallStatus: { ...current.updatingCallStatus, [contactId]: false },
        }));
      });
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/signin" replace={true} />;
    } else {
      return (
        <div>
          <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Web-Contact List
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <DataTable
                    table={{
                      columns: [
                        { Header: "serial", accessor: "serial", width: "6%" },
                        { Header: "name", accessor: "name" },
                        { Header: "email", accessor: "email" },
                        { Header: "mobile", accessor: "mobile" },
                        { Header: "message", accessor: "message" },
                        { Header: "call status", accessor: "call_status" },
                      ],
                      rows: this.state.allJobs.map((job, index) => ({
                        serial: index + 1,
                        name: job?.user_id?._id ? (
                          <Link
                            to={`/user-details/${job.user_id._id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <MDTypography variant="button" color="info" fontWeight="medium">
                              {job?.name || job?.user_id?.name || "-"}
                            </MDTypography>
                          </Link>
                        ) : (
                          job?.name || "-"
                        ),
                        email: job?.email,
                        mobile: job?.mobile,
                        message: job?.message,
                        call_status: (
                          <MarketingCallStatusSelect
                            status={job?.marketing_call_status}
                            disabled={Boolean(this.state.updatingCallStatus[job?._id])}
                            onChange={(callStatus) =>
                              this.handleCallStatusChange(job?._id, callStatus)
                            }
                            ariaLabel={`Call status for ${job?.name || "contact"}`}
                          />
                        ),

                        // action: (
                        //   <>
                        //     <div>
                        //       <Link
                        //         to={{
                        //           pathname: "/updatecareer/" + job._id,
                        //           state: { data: job },
                        //         }}
                        //       >
                        //         <MDButton variant="outlined" size="small" color="success">
                        //           Update
                        //         </MDButton>
                        //       </Link>
                        //     </div>
                        //     <div style={{ marginTop: "1rem" }}>
                        //       <MDButton
                        //         variant="outlined"
                        //         size="small"
                        //         color="error"
                        //         onClick={() => this.handleDelete(job._id)}
                        //       >
                        //         Delete
                        //       </MDButton>
                        //     </div>
                        //   </>
                        // ),
                      })),
                    }}
                  />
                </MDBox>
                <>
                  <MDSnackbar
                    color={this.state.noticolor}
                    icon="notifications"
                    title="AgriQuiz"
                    content={this.state.message}
                    dateTime="Just now"
                    open={this.state.notification}
                    //   close={toggleSnackbar}
                  />
                </>
              </Card>
            </MDBox>
          </DashboardLayout>
        </div>
      );
    }
  }
}
